import React from "react";
import { io } from "socket.io-client";
import { socketNamespace } from "./runtime";

const socket = io(socketNamespace("/lobby"), {
  autoConnect: false,
  withCredentials: true,
});

export const socketContext = {
  socket: socket,
};

export const SocketContext = React.createContext(socketContext);
